/**
 * Parent items, BOM versions, and BOM lines API calls.
 */

import client from './client';

// --- Parent Items ---

export async function fetchParentItemsList(params = {}) {
  const { data } = await client.get('/parent-items/', { params });
  return data;
}

export async function fetchParentItem(id) {
  const { data } = await client.get(`/parent-items/${id}/`);
  return data.data || data;
}

export async function createParentItem(payload) {
  const { data } = await client.post('/parent-items/', payload);
  return data.data || data;
}

export async function updateParentItem(id, payload) {
  const { data } = await client.patch(`/parent-items/${id}/`, payload);
  return data.data || data;
}

export async function deleteParentItem(id) {
  await client.delete(`/parent-items/${id}/`);
}

export async function restoreParentItem(id) {
  const { data } = await client.post(`/parent-items/${id}/restore/`);
  return data.data || data;
}

// --- BOM Versions ---

export async function fetchBomVersions(params = {}) {
  const { data } = await client.get('/parent-items/bom-versions/', { params });
  return data;
}

export async function fetchBomVersion(id) {
  const { data } = await client.get(`/parent-items/bom-versions/${id}/`);
  return data.data || data;
}

export async function createBomVersion(payload) {
  const { data } = await client.post('/parent-items/bom-versions/', payload);
  return data.data || data;
}

export async function updateBomVersion(id, payload) {
  const { data } = await client.patch(`/parent-items/bom-versions/${id}/`, payload);
  return data.data || data;
}

export async function deleteBomVersion(id) {
  await client.delete(`/parent-items/bom-versions/${id}/`);
}

// --- BOM Lines ---

export async function fetchBomLinesForVersion(params = {}) {
  const { data } = await client.get('/parent-items/bom-lines/', { params });
  return data;
}

export async function createBomLineForVersion(payload) {
  const { data } = await client.post('/parent-items/bom-lines/', payload);
  return data.data || data;
}

export async function updateBomLineForVersion(id, payload) {
  const { data } = await client.patch(`/parent-items/bom-lines/${id}/`, payload);
  return data.data || data;
}

export async function deleteBomLineForVersion(id) {
  await client.delete(`/parent-items/bom-lines/${id}/`);
}

// --- BOM Import ---

export async function importBom(formData) {
  const { data } = await client.post('/parent-items/import-bom/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function downloadBomTemplate() {
  // Returns a sample CSV blob the user can open in Excel
  const headers = ['PartNumber', 'Quantity', 'Description', 'User Name', 'Cost', 'HSH PT#', 'Supplier', 'url', 'line_notes'];
  const example = ['PL1/4-N1', '2', '1/4" TUBE X 1/8" MNPT ELBOW PUSH IN', 'PL2501-04-02', '2.53', 'PL2501-04-02', 'ADVANCED TECHNOLOGY PRODUCTS', '', ''];
  const csv = [headers.join(','), example.join(',')].join('\n');
  return new Blob([csv], { type: 'text/csv' });
}
